import { Scale } from "@pdfking/math"

import type { CalendarArea, CalendarBoxes } from "#internal"

import { Slice } from "../layout/Slice"
import { Area } from "./Area"
import { CaptionText } from "./CaptionText"

/** A page of a calendar's cover, a Copertina or a desk calendar's Basetta
 * alike: the pattern down to its middle, the year carved out of it at the top
 * of the security, the calendar's footer at its foot. */
export const CalendarCoverPage = ({
  contact,
  outer,
  page,
  short,
  year,
}: CalendarBoxes): CalendarArea[] => [
  Area.picture(
    Slice.top(page, Scale(page.height, 0.5))[0],
    "cover",
    false,
    CaptionText(Slice.top(outer, Scale(short, 0.1))[0], `${year}`),
    true
  ),
  Area.footer(contact),
]
